var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNewAppointment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "21px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.75190817,4.3248968 L4.90089978,4.3248968 L4.91215719,2.01840745 C4.91350031,1.74322089 5.1369614,1.5208478 5.41215123,1.5208478 L6.41458566,1.5208478 C6.69072803,1.5208478 6.91458566,1.74470542 6.91458566,2.0208478 L6.91458566,4.3248968 L9.07512031,4.3248968 C9.35126269,4.3248968 9.57512031,4.54875443 9.57512031,4.8248968 L9.57512031,5.84870554 C9.57512031,6.12484791 9.35126269,6.34870554 9.07512031,6.34870554 L6.90832263,6.34870554 L6.90832263,8.53018451 C6.90832263,8.80632688 6.684465,9.03018451 6.40832263,9.03018451 L5.40345822,9.03018451 C5.12731584,9.03018451 4.90345822,8.80632688 4.90345822,8.53018451 C4.90345822,8.52933387 4.90346039,8.52848324 4.90346473,8.52763261 L4.91458566,6.34870554 L2.75190817,6.34870554 C2.47576579,6.34870554 2.25190817,6.12484791 2.25190817,5.84870554 L2.25190817,4.8248968 C2.25190817,4.54875443 2.47576579,4.3248968 2.75190817,4.3248968 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-68.3%",
    y: "-53.3%",
    width: "236.6%",
    height: "233.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0235294118   0 0 0 0 0.615686275   0 0 0 0 0.870588235  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,16.4274473 C24.5,16.979732 24.0522847,17.4274473 23.5,17.4274473 C22.9477153,17.4274473 22.5,16.979732 22.5,16.4274473 L22.5,15 C22.5,14.4477153 22.9477153,14 23.5,14 C24.0522847,14 24.5,14.4477153 24.5,15 L24.5,16.4274473 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-250.0%",
    y: "-116.7%",
    width: "600.0%",
    height: "391.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0235294118   0 0 0 0 0.615686275   0 0 0 0 0.870588235  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,16.4274473 C20.5,16.979732 20.0522847,17.4274473 19.5,17.4274473 C18.9477153,17.4274473 18.5,16.979732 18.5,16.4274473 L18.5,15 C18.5,14.4477153 18.9477153,14 19.5,14 C20.0522847,14 20.5,14.4477153 20.5,15 L20.5,16.4274473 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-250.0%",
    y: "-116.7%",
    width: "600.0%",
    height: "391.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0235294118   0 0 0 0 0.615686275   0 0 0 0 0.870588235  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,16.4274473 C28.5,16.979732 28.0522847,17.4274473 27.5,17.4274473 C26.9477153,17.4274473 26.5,16.979732 26.5,16.4274473 L26.5,15 C26.5,14.4477153 26.9477153,14 27.5,14 C28.0522847,14 28.5,14.4477153 28.5,15 L28.5,16.4274473 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-250.0%",
    y: "-116.7%",
    width: "600.0%",
    height: "391.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0235294118   0 0 0 0 0.615686275   0 0 0 0 0.870588235  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.0960487,20.9521709 L16.6960487,20.9521709 C16.5303633,20.9521709 16.3960487,20.8178563 16.3960487,20.6521709 L16.3960487,18.4298389 C16.3960487,17.3252694 17.2914792,16.4298389 18.3960487,16.4298389 L28.2297798,16.4298389 C29.3343493,16.4298389 30.2297798,17.3252694 30.2297798,18.4298389 L30.2297798,26.8305262 C30.2297798,27.9350957 29.3343493,28.8305262 28.2297798,28.8305262 L24.4701045,28.8305262 C24.304419,28.8305262 24.1701045,28.6962116 24.1701045,28.5305262 L24.1701045,27.1305262 C24.1701045,26.9648407 24.304419,26.8305262 24.4701045,26.8305262 L28.2297798,26.8305262 L28.2297798,18.4298389 L18.3960487,18.4298389 L18.3960487,20.6521709 C18.3960487,20.8178563 18.2617342,20.9521709 18.0960487,20.9521709 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-36.1%",
    y: "-32.3%",
    width: "172.3%",
    height: "180.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0235294118   0 0 0 0 0.615686275   0 0 0 0 0.870588235  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.2883337,21.6 L20.2883337,20.4 C20.2883337,20.1790861 20.4674198,20 20.6883337,20 L21.8883337,20 C22.1092476,20 22.2883337,20.1790861 22.2883337,20.4 L22.2883337,21.6 C22.2883337,21.8209139 22.1092476,22 21.8883337,22 L20.6883337,22 C20.4674198,22 20.2883337,21.8209139 20.2883337,21.6 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-250.0%",
    y: "-200.0%",
    width: "600.0%",
    height: "600.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0235294118   0 0 0 0 0.615686275   0 0 0 0 0.870588235  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24,21.6 L24,20.4 C24,20.1790861 24.1790861,20 24.4,20 L25.6,20 C25.8209139,20 26,20.1790861 26,20.4 L26,21.6 C26,21.8209139 25.8209139,22 25.6,22 L24.4,22 C24.1790861,22 24,21.8209139 24,21.6 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-250.0%",
    y: "-200.0%",
    width: "600.0%",
    height: "600.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0235294118   0 0 0 0 0.615686275   0 0 0 0 0.870588235  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24,24.6 L24,23.4 C24,23.1790861 24.1790861,23 24.4,23 L25.6,23 C25.8209139,23 26,23.1790861 26,23.4 L26,24.6 C26,24.8209139 25.8209139,25 25.6,25 L24.4,25 C24.1790861,25 24,24.8209139 24,24.6 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-250.0%",
    y: "-200.0%",
    width: "600.0%",
    height: "600.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0235294118   0 0 0 0 0.615686275   0 0 0 0 0.870588235  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-button-secondary-add-new-appointment",
    transform: "translate(-12.000000, -12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bills-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }), /*#__PURE__*/React.createElement("g", {
    id: "medication-icon",
    transform: "translate(11.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    transform: "translate(8.343678, 8.184015) rotate(-45.000000) translate(-8.343678, -8.184015) translate(2.343678, 2.684015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-4",
    transform: "translate(5.913514, 5.275516) rotate(-135.000000) translate(-5.913514, -5.275516) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#208CFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Path-11"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#208CFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-11-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#208CFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-11-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#208CFF",
    fillRule: "evenodd",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-9"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#208CFF",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-10"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#208CFF",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-10-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#208CFF",
    fillRule: "evenodd",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path-10-Copy-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#208CFF",
    fillRule: "evenodd",
    xlinkHref: "#path-15"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewAppointment);
export default __webpack_public_path__ + "static/media/addNewAppointment.073b3f65962db68770d69338f804e6bf.svg";
export { ForwardRef as ReactComponent };